export default "__VITE_ASSET__C27nbv2k__"